<script setup lang="ts">
import type { CommandItemBaseProps } from "./types";
import { ListOrderedIcon } from "lucide-vue-next";
import SuggestionListItem from "../suggestions/SuggestionListItem.vue";

const props = defineProps<CommandItemBaseProps>();

function run() {
  props.editor
    .chain()
    .focus()
    .deleteRange(props.range)
    .insertBelow(({ escapeList: true, onlyIfEmpty: true }))
    .toggleOrderedList()
    .run();
}

defineExpose({ run });
</script>

<template>
  <SuggestionListItem
    :icon="ListOrderedIcon"
    shortcut="1."
    @click="run"
    @keydown.enter="run"
  >
    Numbered list
  </SuggestionListItem>
</template>
